import * as fromClient from '../reducers/client.reducer';
import { ClientActions } from '../actions/client.action'; // Import ClientActions

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ActionReducerMap } from '@ngrx/store';
import { InjectionToken } from '@angular/core';

export interface ClientState {
  clients: fromClient.ClientsState;
}

export const CLIENT_REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<ClientState, ClientActions>
>('Client Reducers'); // Update InjectionToken with ClientActions

export function getClientReducer(): ActionReducerMap<ClientState, ClientActions> {
  // Update ActionReducerMap type
  // map of reducers
  return {
    clients: fromClient.ClientReducer,
  };
}

const getClientState = createFeatureSelector<ClientState>('client-manager');

export const confirmClientAction = createSelector(getClientState, (state) => state.clients);

export const getClients = createSelector(getClientState, (state) => state.clients);
